<app-navbar></app-navbar>

<section class="min-h-[50dvh] bg-white text-black">
    <div class="w-full">
        <figure class="relative">
            <img src="/assets/img/excellence/tire_knowledge/658422b3108d42fc5f008804_TK_SummerPressure-p-1080.jpg" alt="card image" class="object-cover bg-center w-full h-[60dvh] md:h-[45dvh]"/>
            <figcaption class="absolute bottom-0 left-0 w-full p-6 text-white bg-gradient-to-t from-neutral-950 text-left mx-auto pb-14">
                <div class="max-w-3xl xl:max-w-6xl mx-auto items-center justify-center">
                    <a routerLink="/excellence/tire-knowledge" href="/excellence/tire-knowledge" class="text-green-500 font-semibold text-lg hover:underline">{{back}}</a>
                    <h3 class="text-5xl md:text-6xl font-bold text-green-500">{{texts.title}}</h3>
                    <p class="text-2xl opacity-75 mx-auto">{{texts.subtitle}}</p>
                
                </div>
            </figcaption>
        </figure>
    </div>

    <div class="container mx-auto px-4 md:px-8 py-10">
        <div class="text-justify mb-10">
            
            <div>
                <p class="text-lg mb-4">{{texts.body[0]}}</p>
                <p class="text-lg mb-4">{{texts.body[1]}}</p>
            </div>
        
            <div>
                @for (item of texts.body; track $index) {
                    @if ($index > 1 && $index < 3) {
                        <div class="mb-6">
                            <p class="text-lg font-semibold mb-2">{{item.title}}</p>

                            @for (text of item.body; track $index) {
                                <p class="text-lg mb-2">{{text}}</p>
                            }
                        </div>
                        
                    }

                    @if ($index == 3) {
                        <div class="mb-6">
                            <p class="text-lg font-semibold mb-2">{{item.title}}</p>

                            <p class="text-lg mb-2">{{item.body[0]}}</p>
                            <p class="text-lg mb-2">{{item.body[1]}}</p>

                            <div class="mb-4 ms-6">
                                <ol class="list-disc">
                                    @for (text of item.body[2]; track $index) {
                                        <li class="text-lg mb-2">{{text}}</li>
                                    }
                                    
                                </ol>
                            </div>

                            <p class="text-lg mb-2">{{item.body[3]}}</p>
                            
                        </div>
                        
                    }
                }
                 
            </div>

        </div>
    </div>
</section>

<app-footer></app-footer>